var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "68px",
    viewBox: "0 0 128 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Sync Clouds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0405544554 0.653069307 127.165254 0.653069307 127.165254 67.959604 0.0405544554 67.959604"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-/-Error",
    transform: "translate(-176.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Sync-Clouds",
    transform: "translate(144.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.909677,68 L69.3197307,68 C69.3041848,68 69.2893149,67.9993267 69.273769,67.9993267 C62.4247974,67.9744158 56.4714033,63.212396 54.7336449,56.4016238 C54.549798,55.6805545 54.9871102,54.9480396 55.7110073,54.7649109 C56.436932,54.5824554 57.1702917,55.0173861 57.3541386,55.7377822 C58.7911182,61.3723564 63.6955036,65.3069307 69.2805281,65.3069307 L110.472364,65.3069307 C110.571047,65.2732673 110.675137,65.2503762 110.783958,65.2402772 C118.581228,64.511802 124.461624,57.7892277 124.461624,49.6029703 C124.461624,41.4530693 118.373048,34.5776634 110.600111,33.9508515 C110.099939,33.9104554 109.663303,33.5973861 109.466614,33.1382178 C106.405428,26.003604 99.5902521,21.3944158 92.1045756,21.3944158 C87.8686627,21.3944158 83.8605307,22.8163564 80.5141122,25.5074059 C79.9321558,25.9753267 79.0811881,25.8837624 78.6127842,25.306099 C78.1437043,24.7270891 78.2349518,23.8794455 78.8155564,23.412198 C82.6486284,20.3299802 87.2441241,18.7013465 92.1045756,18.7013465 C100.415535,18.7013465 107.993811,23.6404356 111.624787,31.3506931 C120.402123,32.4824554 127.165254,40.3421782 127.165254,49.6029703 C127.165254,59.0320792 120.453492,66.8076436 111.480143,67.8747723 C111.30711,67.9548911 111.113801,68 110.909677,68",
    id: "Fill-1",
    fill: "#D9DEE1",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7708832,15.3249109 C62.5795802,6.38526733 53.760338,0.653069307 44.0860726,0.653069307 C31.9589386,0.653069307 21.5486099,9.64859406 19.3356884,21.7950099 C18.6841135,21.7189307 18.0284832,21.6798812 17.3769083,21.6798812 C7.79524224,21.6798812 0,29.7072475 0,39.5746535 C0,49.4205149 7.76077096,57.4350891 17.3701492,57.4680792 C17.3877228,57.4687525 17.4052964,57.4694257 17.42287,57.4694257 L66.091596,57.4694257 C66.3078865,57.4694257 66.5113347,57.4189307 66.6924779,57.3293861 C77.0967234,56.1215446 84.8838548,47.1751683 84.8838548,36.3214257 C84.8838548,25.6306139 76.9912818,16.5657426 66.7708832,15.3249109",
    id: "Fill-3",
    fill: "#D9DEE1",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(31.091749, 24.910891)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 5.05578878,
    cy: 3.01623762,
    rx: 3.02806601,
    ry: 3.01623762
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 17.1680528,
    cy: 3.01623762,
    rx: 3.02806601,
    ry: 3.01623762
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2907327,11.8506095 C16.2196291,11.8506095 19.8410146,14.0549197 21.9173634,18.3417215 C22.2807123,19.0918867 21.9647509,19.9934176 21.2116439,20.3553471 C20.4585369,20.7172766 19.5534706,20.4025495 19.1901217,19.6523843 C17.6251768,16.42142 15.0712224,14.8668472 11.2907327,14.8668472 C7.51024296,14.8668472 4.95628854,16.42142 3.39134362,19.6523843 C3.02799476,20.4025495 2.12292846,20.7172766 1.36982146,20.3553471 C0.616714467,19.9934176 0.30075307,19.0918867 0.664101929,18.3417215 C2.74045073,14.0549197 6.36183625,11.8506095 11.2907327,11.8506095 Z",
    id: "Path-3",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsIcon);
export default __webpack_public_path__ + "static/media/clouds-icon.aecc3e7e9b75c2971038b295cbc7d8b5.svg";
export { ForwardRef as ReactComponent };